module.exports = __webpack_public_path__ + "static/img/rwaLogo.dc76e8ec.png";